document.querySelector('.top')?.addEventListener('click', e => {
	e.preventDefault()
	window.scrollTo({ top: 0, behavior: 'smooth' })
})